@for (endpoint of endpoints(); track endpoint.subscriptionInstanceId) {
  @if (endpoint.port; as port) {
    <div class="tabs__grid-item">
      <port-summary
        [service]="port"
        [subscriptionInstanceId]="endpoint.subscriptionInstanceId"
        [vlanranges]="vlanrangeFor(endpoint)"
        style="width: 100%"
      />
    </div>
  }
}
